import { Navigate, createBrowserRouter } from "react-router-dom";

const routes = [
  {
    path: "/",
    settings: {
      layout: {},
    },
    async lazy() {
      let { Layout } = await import("components/Layout");
      return { Component: Layout };
    },
    children: [
      {
        index: true,
        path: "",
        async lazy() {
          let { Home } = await import("pages/Home");
          return {
            Component: Home,
          };
        },
      },
      {
        path: "/home",
        async lazy() {
          let { Home } = await import("pages/Home");
          return {
            Component: Home,
          };
        },
      },
      {
        path: "/application-form",
        async lazy() {
          let { ApplicationForm } = await import("pages/ApplicationForm");
          return {
            Component: ApplicationForm,
          };
        },
      },
      {
        path: "/upload-pdf-application",
        async lazy() {
          let { UploadPdfComp } = await import("pages/UploadPDF");
          return {
            Component: UploadPdfComp,
          };
        },
      },
      {
        path: "/returning-user",
        async lazy() {
          let { ReturningUserComp } = await import("pages/ReturningUser");
          return {
            Component: ReturningUserComp,
          };
        },
      },
      {
        path: "/error",
        async lazy() {
          let { Error404Page } = await import("pages/Error/Error400");
          return {
            Component: Error404Page,
          };
        },
      },
      {
        path: "/success",
        async lazy() {
          let { Success } = await import("pages/Success");
          return {
            Component: Success,
          };
        },
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/error" />,
  },
];

export const router = createBrowserRouter(routes);

export type TRoutes = typeof routes;